const isFullscreenSupported = typeof document.documentElement.requestFullscreen === 'function';
const isPictureInPictureSupported = 'pictureInPictureEnabled' in document;
export { isFullscreenSupported, isPictureInPictureSupported };
